import React from 'react';
import { noop } from 'lodash';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { redirectToOidc } from 'Utils/uri/redirectUtils';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { Button } from 'Components/frameworks/button/Button';
type Props = {
  className?: string;
  comparisonClick: () => void;
  comparisonToggle: () => void;
  comparisonUrl: string;
  isComparisonActive?: boolean;
  isComparisonDisabled?: boolean;
  isComparisonSubmitable?: boolean;
  label: string;
  mandatoryMessage?: string;
  selectedItemsCount?: number;
  selectedItemsMax: number;
};
export const SearchCompareButton = ({
  className,
  comparisonClick,
  comparisonToggle,
  comparisonUrl,
  isComparisonActive,
  isComparisonDisabled = false,
  isComparisonSubmitable,
  label,
  mandatoryMessage,
  selectedItemsCount,
  selectedItemsMax,
}: Props) => {
  const appContext = useAppContext();
  const track = useTracking();
  const isDisabled = isComparisonDisabled || (isComparisonActive && !isComparisonSubmitable);

  const getToggleOrComparisonOnClick = () => {
    if (isComparisonSubmitable) {
      return comparisonClick;
    }

    return isComparisonActive ? noop : comparisonToggle;
  };

  const actualComparisonUrl =
    !appContext.isSeller || appContext.isSellerLogged ? comparisonUrl : appContext.originalUrl;

  if (appContext.isSeller && !appContext.isSellerLogged) {
    redirectToOidc(appContext);
  }

  return (
    <Button
      className={className}
      data-testid="search-compare-button"
      iconRight={{
        name: ICONS.COMPARE,
      }}
      isDisabled={isDisabled}
      onClick={() => {
        getToggleOrComparisonOnClick()();
        track({
          actionGA: 'overlayCTA',
          labelGA: isComparisonSubmitable ? 'compareMySelection' : 'compareAndBook',
        });
      }}
      title={!isComparisonSubmitable ? mandatoryMessage : ''}
      {...(isComparisonSubmitable
        ? {
            url: actualComparisonUrl,
          }
        : {
            type: 'button',
          })}
    >
      {label}
      {!!selectedItemsCount && ` ${selectedItemsCount} / ${selectedItemsMax}`}
    </Button>
  );
};
